import styled from 'styled-components/macro'

export const FormBody = styled.form`
  padding: 0 24px 24px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`

export const ModalSection = styled.div`
  padding: 0 24px;
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  align-items: center;
`

export const Label = styled.label`
  font-size: 13px;
  color: #333;
`

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  &:focus {
    border-color: #999;
  }
  &::placeholder {
    color: #aaa;
  }
  &[readonly] {
    background: #f3f4f6;
    border-color: #e5e7eb;
    color: #6b7280;
    cursor: not-allowed;
  }
`

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  resize: vertical;
  &:focus {
    border-color: #999;
  }
  &::placeholder {
    color: #aaa;
  }
`

export const ErrorText = styled.div`
  grid-column: 1 / -1;
  font-size: 12px;
  color: #d14343;
  line-height: 1.4;
`

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background: #fff;
  &:focus {
    border-color: #999;
  }
`
